module.exports = __webpack_public_path__ + "static/media/location.4ebc219d.svg";